// extracted by mini-css-extract-plugin
module.exports = {"primarycontainer_Promo":"Promo_primarycontainer_Promo__2OpID","secondaryContainer":"Promo_secondaryContainer__3s8On","container_multipleItem":"Promo_container_multipleItem__3z2Qt"};